import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFetchMessagesStatus = createSelector(
  [(store: RootState) => store.users.fetchMessagesStatus],
  (status) => status
);
